import { memo } from "react";
import { makeStyles } from "tss-react/mui";
import { MiButton } from "@miplatform/components";
import { BUTTON_VARIANTS, PERMISSIONS } from "@miplatform/constants";
import { useRouter } from "@miplatform/hooks";
import { usePermissions } from "@mibuildweb/hooks";
import { Box } from "@mui/material";
import { useAccountingContext } from "../../AccountingProvider";
import { AccountingListActionMenu } from "../AccountingListActionMenu/AccountingListActionMenu";

export const InvoicedInvoiceActions = memo((props) => {
  const { classes, theme } = useStyles();
  const { navigate } = useRouter();

  const { actionMenuRef } = useAccountingContext();
  const { hasPermission } = usePermissions();

  const handleNavigateToInvoice = () => {
    navigate(`/accounting/invoices/${props.id}/invoiced`);
  };

  const canViewActions =
    hasPermission(PERMISSIONS.INVOICE.EXPORT) ||
    hasPermission(PERMISSIONS.INVOICE.CREATE) ||
    hasPermission(PERMISSIONS.ORDER.PREBILL);

  return (
    <Box display="flex" flexWrap="wrap" gap={2} alignItems="center">
      <Box className={classes.actionContainer}>
        <MiButton
          title="View Invoice(s)"
          variant={BUTTON_VARIANTS.CONTAINED}
          onClick={handleNavigateToInvoice}
          sx={{ marginRight: theme.spacing(2) }}
        />
        {canViewActions && (
          <AccountingListActionMenu
            {...props}
            ref={actionMenuRef}
            menuViewConfig={{
              forceCloseOut: false,
              printInvoices: true,
              orderActivityDetails: true,
              voidOrder: true,
            }}
          />
        )}
      </Box>
    </Box>
  );
});

const useStyles = makeStyles()((theme) => ({
  actionContainer: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    marginTop: theme.spacing(1),
    [theme.breakpoints.down("xl")]: {
      justifyContent: "space-between",
    },
  },
}));
